import { Injectable, inject } from "@angular/core";
import {Store} from "@ngrx/store";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";
import {getLinkRedirect, getLinkResourceId} from '@link/pages/login/services/link-login-url.helper';

@Injectable({
  providedIn: 'root'
})
export class LinkLoginGuard {
  private store = inject(Store);
  private router = inject(Router);


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const resourceId = getLinkResourceId(route.paramMap.get('id'));
    return this.store.select(SharedLoginSelectors.selectLinkResource).pipe(
      map((resource) => {
        if (resourceId && resource?.resourceId === resourceId && !route.queryParamMap.has('key')) {
          return true;
        } else {
          return this.router.createUrlTree(['link/login'], {
            queryParams: {
              ...route.queryParams,
              resourceId,
              redirect: resourceId ? getLinkRedirect(this.router, state.url, resourceId) : undefined,
            }
          });
        }
      })
    )
  }

}
